import FilterView from 'view/activity/filterView';
// import overpanelView from 'widgets/theoverpanel';
import PartialOverpanelView from 'widgets/partialOverpanel';
import createDateRangePicker from 'view/activity/dateRangePicker/mobileView';
import { extend } from 'underscore';
import Backbone from 'backbone';
import * as presets from 'widgets/datepickerPresets';
import { getActiveShortcut } from 'view/activity/dateRangePicker/stores/shortcutHandling';
const $ = Backbone.$;

const FilterMobileView = FilterView.extend({
	// template: 'activity/inc/filtersOverpanel', // template renders into overpanel

	events: function() {
		return extend(FilterMobileView.__super__.events, {
			'click .js_customDates-shortcut': 'onClickShortcut',
			'click .js_filters-dateButton': 'onClickDateButton'
		});
	},

	createDateRangePicker,

	initialize () {
		// sets the model and validateForm instance
		FilterMobileView.__super__.initialize.apply(this, arguments);

		// Set isDesktopView to false
		this.model.set('isDesktopView', false);
	},

	onClickShortcut (event) {
		let $button = $(event.target),
			presetName = $button.data('preset'),
			[startDate, endDate] = presets[presetName]();
		this.model.setDateFromObject('startDate', startDate);
		this.model.setDateFromObject('endDate', endDate);
		if (this.datePicker) {
			this.datePicker.updateState({ startDate, endDate });
		}
		Backbone.trigger(
			'trackLink',
			null,
			presetName,
			`main:walletweb:activity:opencalendar:${presetName}`,
			null,
			'link'
		);
		this.onFilterView(event);
	},

	openOverlay ({ contentsSelector, onShow, onHide }) {
		if (this._showingOverlay === contentsSelector) {
			return;
		}
		this._showingOverlay = contentsSelector;
		if (this._currentOverlay) {
			this._currentOverlay.destroy().done(() => {
				this.openOverlay({ contentsSelector, onShow });
			});
		} else {
			this._currentOverlay = new PartialOverpanelView({
				el: this.$(contentsSelector)[0],
				container: $('#js_foreground'),
				offsetTop: $('.globalNav_mobile').outerHeight()
			});

			let $originalEl = this.$el;
			// do not use this.setElement as it will undelegate existing events--we want to duplicate listeners, not swap them
			this.$el = this._currentOverlay.$el;
			if (this.$el !== $originalEl) {
				this.delegateEvents();
			}

			if (onShow) {
				this._currentOverlay.on('show', onShow);
			}

			this._currentOverlay.on('destroy', () => {
				this._showingOverlay = false;
				this._currentOverlay = null;
				if (this.$el !== $originalEl) {
					this.undelegateEvents();
					// do not use this.setElement because the original events are still delegated
					this.$el = $originalEl;
				}
				if (onHide) {
					onHide.call(this._currentOverlay);
				}
			});
		}
	},

	getDatePickerElement() {
		return $('.js_customDates-mobileDatePicker')
			.css('display', 'none')
			.removeClass('visible-phone');
	},

	setupDateRangePickerComponent () {
		// do not actually initialize react component until opened
	},

	onClickDateButton (event) {
		event.preventDefault();
		let superView = FilterMobileView.__super__;
		if (this.datePicker) {
			this.delegateEvents();
		}
		this.openOverlay({
			contentsSelector: '#js_datePicker',
			onShow: () => {
				// wait to create the expensive React component on a mobile
				// device until the user actually indicates they want to do
				// manual date selection by opening the date picker overlay.
				if (!this.datePicker) {
					superView.setupDateRangePickerComponent.apply(this);
					// in the desktop view, the date inputs are part of the
					// React component, and so React manages their state
					// based on the global state provided by the View Store.
					//
					// in the mobile view, the date inputs have been left as
					// standard DOM elements to be manipulated by jQuery.
					// this was partly tech debt, but partly a conscious choice
					// to show contrast between the way that jQuery must be
					// used to maintain consistent state, and the way React
					// does it. the below handlers are as simple as possible.
					let syncDatesWithInputs = (state) => {
						let { startDate, endDate, formatDate } = state;
						this.$('#js_filters-startDate')
							.val(formatDate(startDate));
						this.$('#js_filters-endDate')
							.val(formatDate(endDate));
						// the shortcuts are also not part of the React
						// component, so we must also manually update the
						// "active shortcut" state.
						let activeShortcut = getActiveShortcut(startDate, endDate);
						this.$('.js_customDates-shortcut')
							.removeClass('active')
							.filter(`[data-preset="${activeShortcut}"]`)
							.addClass('active');
					};
					// do an initial date input update from the store's
					// initial state.
					syncDatesWithInputs(this.datePicker.getState());

					// every time picker state changes, update the
					// inputs' text values with the state's dates.
					this.datePicker.onUpdate(syncDatesWithInputs);
				}
				// hide the native mobile datepicker fields
				this.$('.customDates-field-mobile').hide();
				this.$('#js_filters-startDate').
					// do not allow mobile devices to enter dates manually
					// using the mobile OS date picker controls
					attr('readOnly', true)
					// bind a click event to the input to initiate the Month
					// with the correct `editing` and `showMonth` values.
					.on('click', () => {
						this.datePicker.updateState({
							editing: 'start',
							showMonth: this.datePicker.getState().startDate
						});
						// in mobile view, focus state won't show, so add
						// a CSS class to simulate it.
						this.$('.js_filters-endDate')
							.closest('.js_form-control')
							.removeClass('active');
						this.$('.js_filters-startDate')
							.closest('.js_form-control')
							.addClass('active');
						// show the month view!
						this.getDatePickerElement().css('display', 'block');
					});
				this.$('#js_filters-endDate').
					// do not allow mobile devices to enter dates manually
					// using the mobile OS date picker controls
					attr('readOnly', true)
					// bind a click event to the input to initiate the Month
					// with the correct `editing` and `showMonth` values.
					.on('click', () => {
						this.datePicker.updateState({
							editing: 'end',
							showMonth: this.datePicker.getState().endDate
						});
						// in mobile view, focus state won't show, so add
						// a CSS class to simulate it.
						this.$('.js_filters-startDate')
							.closest('.js_form-control')
							.removeClass('active');
						this.$('.js_filters-endDate')
							.closest('.js_form-control')
							.addClass('active');
						// show the month view!
						this.getDatePickerElement().css('display', 'block');
					});
			},
			onHide: () => {
				// hide the month view when the overlay hides, to restore
				// the initial state of the date picker UI
				this.getDatePickerElement().css('display', 'none');
			}
		});
	},


	/* Click handler for "View"
	 * Hide the overpanel */
	onFilterView (event) {
		// call super class method for inherited behavior
		FilterMobileView.__super__.onFilterView.apply(this, arguments);
		// close the overpanel, don't trigger auto-navigation to /myaccount/activity
		if (this._currentOverlay) {
			this._currentOverlay.destroy();
		}
	}

});

export default FilterMobileView;



// WEBPACK FOOTER //
// ./view/activity/filterMobileView.es6